import {
  ActionIcon,
  Box,
  Button,
  CopyButton,
  Divider,
  Flex,
  ScrollArea,
  Text,
  Tooltip,
} from '@mantine/core';
import { IconCheck, IconCopy } from '@tabler/icons-react';
import { useMemo } from 'react';

type ReactorsListProps = {
  ids: string[];
};

export const ReactorsList = ({ ids }: ReactorsListProps) => {
  const idList = useMemo(() => ids.join('\n'), [ids]);

  return (
    <Flex direction="column" gap="sm">
      <ScrollArea.Autosize mah={380} offsetScrollbars>
        <Flex direction="column" gap={4} pr={4}>
          {ids.length === 0 && (
            <Text c="dimmed" size="sm" ta="center" py="md">
              No reactors found
            </Text>
          )}

          {ids.map((id, index) => (
            <Box
              key={id}
              style={(theme) => ({
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '6px 10px',
                borderRadius: theme.radius.sm,
                backgroundColor: index % 2 === 0 ? 'transparent' : 'rgba(255,255,255,0.03)',
              })}
            >
              <Text size="xs" c="dimmed" w={24} ta="right" style={{ flexShrink: 0 }}>
                {index + 1}
              </Text>
              <Text size="sm" ff="monospace" style={{ flex: 1 }}>
                {id}
              </Text>
              <CopyButton value={id}>
                {({ copied, copy }) => (
                  <Tooltip label={copied ? 'Copied!' : 'Copy'} withArrow>
                    <ActionIcon
                      variant="subtle"
                      color={copied ? 'teal' : 'gray'}
                      size="sm"
                      onClick={copy}
                      style={{ flexShrink: 0 }}
                    >
                      {copied ? <IconCheck size={13} /> : <IconCopy size={13} />}
                    </ActionIcon>
                  </Tooltip>
                )}
              </CopyButton>
            </Box>
          ))}
        </Flex>
      </ScrollArea.Autosize>

      {ids.length > 0 && (
        <>
          <Divider opacity={0.2} />

          <CopyButton value={idList}>
            {({ copied, copy }) => (
              <Button
                variant="light"
                color={copied ? 'teal' : 'blue'}
                leftSection={copied ? <IconCheck size={14} /> : <IconCopy size={14} />}
                onClick={copy}
                fullWidth
                size="sm"
              >
                {copied ? 'Copied!' : 'Copy All'}
              </Button>
            )}
          </CopyButton>
        </>
      )}
    </Flex>
  );
};
